import { gql } from '@apollo/client';

export const GET_ACCOUNT_FINTRX = gql`
  query GetAccountFintrxByAccount($accountId: ID!) {
    accountFintrx(accountId: $accountId) {
      edges {
        node {
          id
          activeInCoInvestments
          capitalAllocator
          deploysImpactEsgInvestmentStyle
          deploysProgressiveInvestmentStyle
          emergingManagerInterest
          firmRegisteredStatus
          progressiveInvStyle
          secRegisteredStatus
          bestMatchName
          bestMatchWebsite
          firmCrdId
          nameScore
          websiteScore
        }
      }
    }
  }
`;

// GraphQL Response Types
export interface AccountFintrxNode {
  activeInCoInvestments?: boolean | null;
  bestMatchName?: null | string;
  bestMatchWebsite?: null | string;
  capitalAllocator?: boolean | null;
  deploysImpactEsgInvestmentStyle?: boolean | null;
  deploysProgressiveInvestmentStyle?: boolean | null;
  emergingManagerInterest?: boolean | null;
  firmCrdId?: null | string;
  firmRegisteredStatus?: boolean | null;
  id: string;
  nameScore?: null | number;
  progressiveInvStyle?: boolean | null;
  secRegisteredStatus?: boolean | null;
  websiteScore?: null | number;
}

// UI Data Type
export interface FintrxData {
  fintrxActiveInCoInvestments: boolean;
  fintrxBestMatchName: string;
  fintrxBestMatchWebsite: string;
  fintrxCapitalAllocator: boolean;
  fintrxDeploysImpactEsgInvestmentStyle: boolean;
  fintrxDeploysProgressiveInvestmentStyle: boolean;
  fintrxEmergingManagerInterest: boolean;
  fintrxFirmCrdId: string;
  fintrxFirmRegisteredStatus: boolean;
  fintrxNameScore: null | number;
  fintrxProgressiveInvStyle: boolean;
  fintrxSecRegisteredStatus: boolean;
  fintrxWebsiteScore: null | number;
}

export interface GetAccountFintrxData {
  accountFintrx: {
    edges: {
      node: AccountFintrxNode;
    }[];
  };
}

export interface GetAccountFintrxVariables {
  accountId: string;
}

// Helper
export function createEmptyFintrxData(): FintrxData {
  return {
    fintrxActiveInCoInvestments: false,
    fintrxBestMatchName: '',
    fintrxBestMatchWebsite: '',
    fintrxCapitalAllocator: false,
    fintrxDeploysImpactEsgInvestmentStyle: false,
    fintrxDeploysProgressiveInvestmentStyle: false,
    fintrxEmergingManagerInterest: false,
    fintrxFirmCrdId: '',
    fintrxFirmRegisteredStatus: false,
    fintrxNameScore: null,
    fintrxProgressiveInvStyle: false,
    fintrxSecRegisteredStatus: false,
    fintrxWebsiteScore: null
  };
}

// Mapper
export function mapFintrxData(node: AccountFintrxNode): FintrxData {
  return {
    fintrxActiveInCoInvestments: node.activeInCoInvestments ?? false,
    fintrxBestMatchName: node.bestMatchName ?? '',
    fintrxBestMatchWebsite: node.bestMatchWebsite ?? '',
    fintrxCapitalAllocator: node.capitalAllocator ?? false,
    fintrxDeploysImpactEsgInvestmentStyle:
      node.deploysImpactEsgInvestmentStyle ?? false,
    fintrxDeploysProgressiveInvestmentStyle:
      node.deploysProgressiveInvestmentStyle ?? false,
    fintrxEmergingManagerInterest: node.emergingManagerInterest ?? false,
    fintrxFirmCrdId: node.firmCrdId ?? '',
    fintrxFirmRegisteredStatus: node.firmRegisteredStatus ?? false,
    fintrxNameScore: node.nameScore ?? null,
    fintrxProgressiveInvStyle: node.progressiveInvStyle ?? false,
    fintrxSecRegisteredStatus: node.secRegisteredStatus ?? false,
    fintrxWebsiteScore: node.websiteScore ?? null
  };
}
